import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@src/app/shared/shared.module';
import { IbDigitalMenuModalComponent } from './components/ib-digital-menu/ib-digital-menu-modal.component';
import { IbGastronomicProposalUtilsService } from './services/ib-gastronomic-proposal-utils.service';
import { IbDigitalMenuContentComponent } from './components/ib-digital-menu/components/ib-digital-menu-content/ib-digital-menu-content.component';
import { IbDigitalMenuWineComponent } from './components/ib-digital-menu/components/ib-digital-menu-wine/ib-digital-menu-wine.component';
import { IbDigitalMenuItemComponent } from './components/ib-digital-menu/components/ib-digital-menu-item/ib-digital-menu-item.component';
import { IbDigitalMenuAllergensInfoComponent } from './components/ib-digital-menu/components/ib-digital-menu-allergens-info/ib-digital-menu-allergens-info.component';
import { IbDigitalMenuService } from './services/ib-digital-menu.service';
import { IbSpecialMealsService } from './services/ib-special-meals.service';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        TranslateModule,
        NgbModule,
        SharedModule
    ],
    declarations: [
        IbDigitalMenuModalComponent,
        IbDigitalMenuContentComponent,
        IbDigitalMenuWineComponent,
        IbDigitalMenuItemComponent,
        IbDigitalMenuAllergensInfoComponent
    ],
    exports: [
        IbDigitalMenuModalComponent,
        IbDigitalMenuContentComponent,
        IbDigitalMenuWineComponent,
        IbDigitalMenuItemComponent,
        IbDigitalMenuAllergensInfoComponent
    ],
    providers: [IbGastronomicProposalUtilsService, IbDigitalMenuService, IbSpecialMealsService]
})

export class IbMmmbGastronomicProposalModule { }
export {IbDigitalMenuModalComponent} from './components/ib-digital-menu/ib-digital-menu-modal.component';
export {IbDigitalMenuContentComponent} from './components/ib-digital-menu/components/ib-digital-menu-content/ib-digital-menu-content.component';
